import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { MdDoDisturb, MdOutlineExpandMore } from 'react-icons/md';
// import { SpinnerLoader } from '..';
import classes from './CustomReactSelect.module.scss';

const readOnlyControlStyles = {
    borderColor: 'transparent',
    pointerEvents: 'none',
    cursor: 'not-allowed',
    boxShadow: 'none',
    padding: '0',
    '&:hover': {
        borderColor: 'transparent',
    },
};

const readOnlyPlaceholderStyles = {
    color: 'transparent',
};

const readOnlyDropdownIndicatorStyles = {
    display: 'none',
};

const readOnlyValueContainerStyles = {
    padding: 0,
};

const readOnlySingleValueStyles = {
    fontWeight: '500',
    color: 'var(--neutral-700)',
};

const CustomReactSelect = (props) => {
    const { icon, noOptionsText = 'No options', isReadOnly = false } = props;

    const customStyles = {
        dropdownIndicator: (styles) => ({
            ...styles,
            padding: '0px',
            ...(isReadOnly && readOnlyDropdownIndicatorStyles),
        }),
        control: (styles, ...props) => {
            return {
                ...styles,
                borderColor: 'var(--neutral-200)',
                borderRadius: 'var(--border-radius-md)',
                pointerEvents: props.isDisabled ? 'auto' : '',
                cursor: props.isDisabled ? 'not-allowed' : 'Default',
                paddingLeft: icon ? '24px' : '10px',
                paddingRight: '10px',
                minHeight: '38px',
                boxShadow: 'none',
                // '&:hover': {
                //     borderColor: 'var(--primary-500)',
                // },
                ...(isReadOnly && readOnlyControlStyles),
            };
        },
        placeholder: (styles) => ({
            ...styles,
            fontSize: '14px',
            ...(isReadOnly && readOnlyPlaceholderStyles),
        }),
        menu: (styles, state) => ({
            ...styles,
            border: '1px solid #f6f6f6',
            borderRadius: 'var(--border-radius-md)',
            boxShadow: 'var(--box-shadow-md)',
            padding: '10px 2px 10px 8px',
            zIndex: 99,
        }),
        // menuList: (styles, state) => ({
        //     ...styles,
        // }),
        option: (styles, state) => ({
            ...styles,
            textAlign: 'left',
            marginBottom: '4px',
            cursor: 'pointer',
            borderRadius: 'var(--border-radius-md)',
            color: state.isSelected ? 'var(--neutral-800)' : 'var(--neutral-600)',
            backgroundColor: state.isFocused || state.isSelected ? 'var(--primary-100)' : 'none',
            transition: '0.1s ease-in-out',
            '&:hover': {
                backgroundColor: 'var(--primary-100)',
            },
        }),
        valueContainer: (styles) => ({
            ...styles,
            ...(isReadOnly && readOnlyValueContainerStyles),
            maxHeight:'80px',
            overflowY: 'auto',
            minHeight: 'inherit'
        }),
        singleValue: (styles) => ({
            ...styles,
            ...readOnlySingleValueStyles
        }),
    };

    const noOptionsMessage = () => noOptionsText;

    return (
        <div className={classes.CustomReactSelectWrap}>
            {icon ? (
                <span className={`${classes.SelectIcon} ${classes.LeftIcon}`}>{icon}</span>
            ) : null}
            <Select
                components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: ({ isDisabled, ...rest }) => (
                        <components.DropdownIndicator {...rest}>
                            {!isDisabled ? (
                                <span className={classes.SelectIcon}>
                                    <MdOutlineExpandMore />
                                </span>
                            ) : (
                                <span className={classes.SelectIcon}>
                                    <MdDoDisturb />
                                </span>
                            )}
                        </components.DropdownIndicator>
                    ),
                    // Control: ({ children, ...rest }) => (
                    //     <components.Control {...rest}>
                    //         {icon && <span className={classes.SelectIcon}>{icon}</span>} {children}
                    //     </components.Control>
                    // ),
                }}
                styles={customStyles}
                className="react-select-container"
                classNamePrefix="react-select"
                noOptionsMessage={noOptionsMessage}
                {...props}
            />
        </div>
    );
};

CustomReactSelect.propTypes = {
    icon: PropTypes.element,
    noOptionsText: PropTypes.string,
};

export default CustomReactSelect;
